import { render, staticRenderFns } from "./CommonCodeManage.vue?vue&type=template&id=09f6a8a1&scoped=true&"
import script from "./CommonCodeManage.vue?vue&type=script&lang=js&"
export * from "./CommonCodeManage.vue?vue&type=script&lang=js&"
import style0 from "./CommonCodeManage.vue?vue&type=style&index=0&id=09f6a8a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f6a8a1",
  null
  
)

export default component.exports